module.exports = __webpack_public_path__ + "static/media/What_is_NiaUpdated.d2cde4e6.webm";